<ng-container *transloco="let t; prefix: 'shared.autocomplete.search-property.property-item'">
  <a [href]="activeLang + '/properties/' + property.code" target="_blank"
    class="flex items-start gap-4 py-5 px-5 w-full text-sm text-gray-700 cursor-pointer hover:bg-gray-100">
    <div class="flex">
      @if (property.defaultImagePath) {
      <img class="h-[60px] w-[90px] rounded-[2px]" [src]="property.defaultImagePath"
        [alt]="property.defaultPhoto?.altText">
      } @else {
      <div class="h-[60px] w-[90px] flex items-center justify-center bg-gray-200 rounded-[2px]">
      </div>
      }
    </div>
    <div class="flex flex-1 w-full">
      <div class="flex flex-col gap-2 w-full">
        <div class="flex flex-col gap-0.5 w-full">
          <p class="text-md text-black font-semibold">
            {{ property.title || 'Untitled' }}
          </p>
          <!-- @if (property.address) {
            <p class="text-gray-900 text-xs">
              {{ property.address.streetName }} {{ property.address.prefecture }}
            </p>
          } -->
        </div>
        <div class="flex flex-row w-full gap-2">
          @if (property.constructionYear) {
          <span class="text-gray-900 text-xs">{{ property.constructionYear }}</span>
          <span class="bg-gray-600 rounded-full w-2 h-2 my-auto"></span>
          }
          @if (property.floor) {
          <span class="text-gray-900 text-xs">
            {{ property.floor }}{{ t('number-floor') }}
          </span>
          <span class="bg-gray-600 rounded-full w-2 h-2 my-auto"></span>
          }
          @if (property.numberOfRooms) {
          <span class="text-gray-900 text-xs">
            {{ property.numberOfRooms }} {{ property.numberOfRooms > 1 ? t('bedroom-plural') : t('bedroom') }}
          </span>
          <span class="bg-gray-600 rounded-full w-2 h-2 my-auto"></span>
          }
          @if (property.numberOfBathrooms) {
          <span class="text-gray-900 text-xs">
            {{ property.numberOfBathrooms }} {{ property.numberOfBathrooms > 1 ? t('bathroom-plural') : t('bathroom') }}
          </span>
          }
        </div>
      </div>
    </div>
  </a>
</ng-container>